import axios from "axios";
import LocalStorageService from "./LocalStorageService";
import { authorizationStore } from "./authorizationStore";
import webAppConfig from "../commons/webApp.config";

const requestConfig = {
  baseURL: webAppConfig.baseURL,
};

function getClient() {
  let client = axios.create({
      ...requestConfig,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + LocalStorageService.getAccessToken(),
        "tz": Intl.DateTimeFormat().resolvedOptions().timeZone
      }
  });

  client.interceptors.request.use(
    config => {
      const authorization = config.headers.Authorization;
      if (!authorization || authorization === 'Bearer undefined' || authorization === 'Bearer null') {
        authorizationStore.dispatch('logout', { status: 464 });
        return Promise.reject(new Error('No credentials'));
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use((response) => {
    return response;
  }, async function (error) {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
          let localStorage = LocalStorageService;
          originalRequest._retry = true;
          const refreshToken = localStorage.getRefreshToken();

          if (!refreshToken || refreshToken == 'undefined') {
            authorizationStore.dispatch('logout', { status: 461 });
            return Promise.reject(error);
          }

          const maxRetries = 3;
          for(let retryCount = 1; retryCount <= maxRetries; retryCount++) {
            try {
              const res = await axios.post(
                '/token', 
                `grant_type=refresh_token&refresh_token=${refreshToken}`, 
                {
                  ...requestConfig,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }
              );

              localStorage.setToken(res.data);
              client.defaults.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
              originalRequest.headers['Authorization'] = 'Bearer ' + localStorage.getAccessToken();
              return axios(originalRequest);
            } catch(err) {
              console.error(`Authorization:Interceptor:RefreshToken. Attempt ${retryCount}.`, err);
              const errorResponseStatus = err.response && err.response.status;

              if (retryCount >= maxRetries || errorResponseStatus === 401) {
                console.error("Authorization:Interceptor:RefreshToken. Autologout", err);
                let status = null;

                if (errorResponseStatus === 400) {
                  status = 462;
                } else if (errorResponseStatus == 500) {
                  status = 463;
                }

                authorizationStore.dispatch('logout', { status: status });
              }

              await new Promise(resolve => setTimeout(resolve, 1000));
            }
          }
      } else if (error.response && error.response.status === 401) {
        authorizationStore.dispatch('logout', { status: 465 });
      } else {
        console.error(['Authorization:Interceptor'], error);
      }
      return Promise.reject(error);
  });
  return client;
}

export const commonStore = {
  state: {
    client: getClient(),
  }
}